/* global hj */
/* global delightedNps3 */
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import _template from 'lodash/template';
import CompleteEndstate from 'styles/blocks/endstate/complete';
import { Spinner } from 'styles/blocks/spinner';
import { ColumnDiv } from 'styles/elements/div';
import { H1 } from 'styles/elements/headers';
import { Text } from 'styles/elements/text';
import media from 'styles/media';
import { fadeIn, fadeOut } from 'styles/animations';
import { STRINGS } from 'config';

const dotStyles = css`
  background-color: ${props => props.theme.buttonPrimaryBackgroundColor};
  height: 20px;
  width: 20px;
  border-radius: 5px;
  margin: 3px 5px;
`;

const spinnerStyles = css`
  align-self: flex-start;
  animation-delay: 0s;
  margin: 20px 0 40px;
`;

const Loading = styled(ColumnDiv)`
  padding: 30px 12%;
  opacity: 0;
  animation: ${fadeIn} 3s;
  animation-fill-mode: forwards;
  ${media.extraSmallAndBelow`
    padding: 10px 3.5%;
  `}
`;

const LoadingText = styled.div`
  position: absolute;
  margin-top: 85px;
  animation: ${fadeOut} 3s 3s;
  animation-fill-mode: forwards;
`;

const LongerLoadingText = styled(LoadingText)`
  opacity: 0;
  animation: ${fadeIn} 4s 3.3s;
  animation-fill-mode: forwards;
`;

export const Complete = ({ text, formattedResponseDateTime, isPopupSurveyAvailableForProduct, product, conditionName, consultationId, practiceName }) => {
  useEffect(() => {
    if (typeof delightedNps3 !== 'undefined' && delightedNps3.survey && isPopupSurveyAvailableForProduct && formattedResponseDateTime) {
      const touchpoint = product === STRINGS.PRODUCT.PRIMARY_CARE ? 'PatientConfirmation' : 'OutpatientConfirmation';
      delightedNps3.survey({ properties: { touchpoint, conditionName, consultationId, practiceName } });
    }
    if (typeof hj !== 'undefined' && isPopupSurveyAvailableForProduct && formattedResponseDateTime) {
      hj('stateChange', `${product}/complete`);
    }
  }, [isPopupSurveyAvailableForProduct, formattedResponseDateTime, product, conditionName, consultationId, practiceName]);
  if (!formattedResponseDateTime) {
    return (
      <CompleteEndstate ie9Height={600}>
        <Loading>
          <Spinner isVisible spinnerStyles={spinnerStyles} dotStyles={dotStyles} />
          <LoadingText>
            <H1>Submitting your request...</H1>
          </LoadingText>
          <LongerLoadingText>
            <H1>Please wait while we submit your request</H1>
            <Text>Our service is a little busier than usual.<strong> Don&apos;t try to refresh the page.</strong></Text>
          </LongerLoadingText>
        </Loading>
      </CompleteEndstate>
    );
  }
  const compiled = _template(text);
  const textWithDates = compiled({ formattedResponseDateTime: `<strong>${formattedResponseDateTime}</strong>` });
  const createMarkup = htmlContent => ({ __html: htmlContent });
  return (
    <CompleteEndstate ie9Height={600}>
      <CompleteEndstate.ReceivedHTML dangerouslySetInnerHTML={createMarkup(textWithDates)} />
    </CompleteEndstate>
  );
};
